import React, { useCallback } from 'react';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepContent from '@material-ui/core/StepContent';
import PropTypes from 'prop-types';
import VerticalLabel from '../VerticalLabel';

import useStyles from '../useStyles';

const VerticalStepper = (props) => {
  const { content, activeStep, handleGoToStep, steps, unlockedSteps, currentStep } = props;
  const classes = useStyles();

  const getIsTouched = useCallback((step) => step.n <= currentStep.n, [currentStep.n]);
  const getIsCurrent = useCallback((step) => step.n === currentStep.n, [currentStep.n]);

  const handleClick = (step, index) => {
    if (unlockedSteps.includes(step.id)) {
      handleGoToStep(step, index);
    }
  };

  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} orientation="vertical">
        {steps.map((step, index) => (
          <Step key={step.id}>
            <VerticalLabel
              handleClick={handleClick}
              step={step}
              index={index}
              isTouched={getIsTouched(step)}
              isCurrent={getIsCurrent(step)}
            />
            <StepContent>{content}</StepContent>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};

VerticalStepper.propTypes = {
  content: PropTypes.element,
  activeStep: PropTypes.number.isRequired,
  handleGoToStep: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.shape({}),
      label: PropTypes.string,
    }),
  ).isRequired,
  unlockedSteps: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentStep: PropTypes.shape({
    n: PropTypes.number,
  }).isRequired,
};

VerticalStepper.defaultProps = {
  content: <></>,
};

export default VerticalStepper;
